import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../../../shared/theme/useColorScheme";

interface MobileDeviceStatusDialogButtonStyles {
  headingLabel: ICSSInJSStyle;
  descriptionLabel: ICSSInJSStyle;
  dialogIcon: ICSSInJSStyle;
  closeIcon: ICSSInJSStyle;
  dialogBox: ICSSInJSStyle;
  dialogBoxTrigger: ICSSInJSStyle;
  successIcon: ICSSInJSStyle;
  warningIcon: ICSSInJSStyle;
  hyphenIcon: ICSSInJSStyle;
}

export const useMobileDeviceStatusDialogButtonStyles: () => MobileDeviceStatusDialogButtonStyles =
  () => {
    const { main, white, yellow, green } = useFluentColorScheme();

    return {
      headingLabel: {
        maxWidth: "270px",
      },
      descriptionLabel: {
        maxWidth: "315px",
      },
      dialogIcon: {
        position: "static",
        height: "100%",
        width: "100%",
        maxHeight: "200px",
        maxWidth: "200px",
      },
      closeIcon: {
        color: white.foreground,
      },
      dialogBox: {
        width: "343px",
        height: "480px",
        backgroundColor: main.background,
        borderRadius: "8.42px",
      },
      dialogBoxTrigger: {
        cursor: "none",
        backgroundColor: "transparent",
        padding: "0px",
        minWidth: "18px",
        height: "18px",
        width: "18px",
        maxHeight: "20px",
        maxWidth: "20px",
        border: "0px",
        boxShadow: "none",
      },
      successIcon: {
        backgroundColor: green.foreground2,
        color: main.background,
      },
      warningIcon: {
        color: yellow.background,
      },
      hyphenIcon: {
        color: white.foreground,
      },
    };
  };
